"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpoint2xlarge = exports.breakpointXlarge = exports.breakpointLarge = exports.breakpointMedium = exports.breakpointSmall = exports.breakpointXsmall = exports.baseBreakpoint2xlarge = exports.baseBreakpointXlarge = exports.baseBreakpointLarge = exports.baseBreakpointMedium = exports.baseBreakpointSmall = exports.baseBreakpointXsmall = void 0;
exports.baseBreakpointXsmall = 0;
exports.baseBreakpointSmall = 375;
exports.baseBreakpointMedium = 768;
exports.baseBreakpointLarge = 1024;
exports.baseBreakpointXlarge = 1440;
exports.baseBreakpoint2xlarge = 1920;
exports.breakpointXsmall = 0;
exports.breakpointSmall = 375;
exports.breakpointMedium = 768;
exports.breakpointLarge = 1024;
exports.breakpointXlarge = 1440;
exports.breakpoint2xlarge = 1920;